import React, { useEffect } from 'react';

const CAN_SEND = import.meta.env.VITE_IS_DEBUG === 'false';

const GA_ID = import.meta.env.VITE_GA_ID;

const GoogleAnalytics: React.FC = () => {
  useEffect(() => {
    // 開発環境では初期化しない
    if (!CAN_SEND) {
      console.log('GA4 tracking is disabled in development');
      return;
    }

    if (!GA_ID) {
      console.warn('GA ID is missing');
      return;
    }

    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;

    const initScript = document.createElement('script');
    initScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}');
    `;

    document.head.appendChild(gtagScript);
    document.head.appendChild(initScript);
  }, []);

  return null; // このコンポーネントはUIを持たない
};

export default GoogleAnalytics;
